<template>
    <v-layout wrap justify-space-between
              :class="{'background-light body-2 mt-2': $vuetify.breakpoint.xs, 'mt-4': $vuetify.breakpoint.smAndUp}"
    >
        <v-flex class="background-light pa-3 mr-2">
            <div :class="{'pr-3': $vuetify.breakpoint.smAndUp}">
                <div>{{$t("Все курсы пользователей")}}</div>
                <div class="red-text pt-2" :class="{'title': $vuetify.breakpoint.xs, 'display-1': $vuetify.breakpoint.smAndUp}">{{ total_stats.all_course_count }}</div>
            </div>
        </v-flex>
        <v-flex class="background-light pa-3 mr-2">
            <v-layout row align-center :class="{'pr-3': $vuetify.breakpoint.smAndUp}">
                <div :class="{'mr-3': $vuetify.breakpoint.smAndUp}">
                    <div class="mb-2">{{$t("Новые курсы")}}</div>
                    <div>{{ total_stats.new_course_count }}
                        <!-- <span v-if="$vuetify.breakpoint.xs" class="green-text ml-2">32%</span> -->
                    </div>
                </div>
                <v-flex v-if="$vuetify.breakpoint.smAndUp" mr-2>
                    <v-progress-circular
                        :rotate="-90"
                        size="64"
                        :width="6"
                        :value="percent(total_stats.all_course_count, total_stats.new_course_count)"
                        class="green-text"
                    >
                        {{ percent(total_stats.all_course_count, total_stats.new_course_count) }}%
                    </v-progress-circular>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex class="background-light pa-3 mr-2">
            <v-layout row align-center :class="{'pr-3': $vuetify.breakpoint.lgAndUp}">
                <div :class="{'pr-3': $vuetify.breakpoint.smAndUp}">
                    <div class="mb-2">{{$t("Завершенные курсы")}}</div>
                    <div>{{ total_stats.completed_course_count }}
                        <!-- <span v-if="$vuetify.breakpoint.xs" class="grey-text ml-2">50%</span> -->
                    </div>
                </div>
                <v-flex v-if="$vuetify.breakpoint.smAndUp" mr-2>
                    <v-progress-circular
                        :rotate="-90"
                        size="64"
                        :width="6"
                        :value="percent(total_stats.all_course_count, total_stats.completed_course_count)"
                        class="grey-text"
                    >
                        {{ percent(total_stats.all_course_count, total_stats.completed_course_count) }}%
                    </v-progress-circular>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex class="background-light pa-3" :class="{'mt-4': $vuetify.breakpoint.smAndDown}">
            <v-layout row align-center>
                <div class="mr-2">
                    <div class="mb-2">{{$t("Идет обучение")}}</div>
                    <div>{{ total_stats.current_course_count }}
                        <!-- <span v-if="$vuetify.breakpoint.xs" class="red-text ml-2">13%</span> -->
                    </div>
                </div>
                <v-flex v-if="$vuetify.breakpoint.smAndUp" mr-2>
                    <v-progress-circular
                        :rotate="-90"
                        size="64"
                        :width="6"
                        :value="percent(total_stats.all_course_count, total_stats.current_course_count)"
                        class="red-text"
                    >
                        {{ percent(total_stats.all_course_count, total_stats.current_course_count) }}%
                    </v-progress-circular>
                </v-flex>
                <v-flex justify-end class="mr-3">
                    <div class="mb-2">{{$t("Не просрочен")}}</div>
                    <div><span class="green-text mr-2">{{ total_stats.not_expired_course_history_count }}</span><span class="grey-text">({{ percent(total_stats.current_course_count, total_stats.not_expired_course_history_count) }}%)</span></div>
                </v-flex>
                <v-flex class="mr-3">
                    <div class="mb-2">{{$t("Просрочен")}}</div>
                    <div><span class="red-text mr-2">{{ total_stats.expired_course_history_count }}</span><span class="grey-text">({{ percent(total_stats.current_course_count, total_stats.expired_course_history_count) }}%)</span></div>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import {mapGetters, mapMutations, mapActions} from 'vuex';
export default {
  components: {

  },
  computed: {
    ...mapGetters('employee_study', [
      'total_stats',
    ]),
  },
  methods: {
    percent(total, value) {
      if (value<total) {
        return Math.round((value/total)*100);
      } else return 100;
    },
  },
};
</script>
